export default __webpack_public_path__ + "media/images/flags/wi-2f2aa51d613502562a13a45f271c95d3.png";